import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-marklist',
  templateUrl: './marklist.component.html',
  styleUrls: ['./marklist.component.scss']
})
export class MarklistComponent implements OnInit {
  APIService: any;
  sessionId: any;
  userPermission: any;
  UserCollege
  utp: string;
  collegeList: any;
  filteredCollegeList: any;
  coCode: any;
  examList: any;
  filteredListExam: any;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  CourseList: any;
  ReportForm: FormGroup;
  filteredListCourse: any;
  SessionNo: any;
  SessionStatus: any;
  submitpayload: any;
  shId:any;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
    private route: ActivatedRoute

  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {

    this.ReportForm = this.fb.group({
      ShEmId: new FormControl('', Validators.required),
      CgCode: new FormControl(''),
      RollNo: new FormControl('')
    });

    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.show();
      this.SessionNo = res.projectPharam['SnNo'];
      this.SessionStatus = res.projectPharam['SnStatus'];
      const payload = {};
      payload['LoginId'] = sessionStorage.getItem('userId')
      payload['ShSnNo'] = this.SessionNo
      payload['ShStatus'] = ''
      // this.umsService.getExam(payload).subscribe(res => {
      this.umsService.ReportExm(payload).subscribe(res => {
        if (res.status) {          
          this.spinner.hide();
          this.examList = res.data;
          this.filteredListExam = this.examList.slice();
        }
        else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      });


    }
    );

  }



  getClg(item: any) {
    this.shId = item.ShId
    this.spinner.show();
    const payload = {};

    payload['EmId'] = item.ShEmId
    this.umsService.getExamCollegeForReport(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }



  Print() {
    this.submitpayload = this.ReportForm.value;
    var filter: any;
      let payload1 = {}
     // payload1['SessionNo'] = this.SessionNo;
      payload1['EmId'] = parseInt(this.submitpayload['ShEmId']);
     // payload1['StuRgNo'] = parseInt(this.submitpayload['RollNo']);
      let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
      var filter: any;

    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 309,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": this.shId,
      "CgCode": this.submitpayload['CgCode'],
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": parseInt(this.submitpayload['RollNo']),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }



  Back() {
    this.goBack();
  }
  goBack(): void {
    // this.location.back(); // This will navigate back to the previous page
  }
}
